import React from 'react';

import ClaimsTableCell from './ClaimsTableCell';
import ClaimStatusBadge from '../../parcel-finder/ClaimStatusBadge/ClaimStatusBadge';
import ClaimsTypeBadge from './ClaimsTypeBadge';
import ClaimsValue from './ClaimsValue';
import Text from '../../common/Text/Text';
import ClaimsTableActionDropdownButton from './ClaimsTableActionDropdownButton';
import ClaimsTableSubmissionDate from './ClaimsTableSubmissionDate';
import DorStatusBadge from './DorStatusBadge';
import { ListClaim } from '../../../api/types';

import './ClaimsTableRow.scss';

interface ClaimsTableRowProps {
  claim: ListClaim;
  onTakeActionButtonClick: (claim: ListClaim) => void;
  onCancelClaimButtonClick: (claim: ListClaim) => void;
  onContinueClaimSubmission: (claim: ListClaim) => void;
}

function ClaimsTableRow({
  claim,
  onTakeActionButtonClick,
  onCancelClaimButtonClick,
  onContinueClaimSubmission,
}: ClaimsTableRowProps) {
  const { status, claimType, netValueCurrency, netValue, trackingCode, dorStatus, id, recipientCountryCode } = claim;

  return (
    <tr data-testid="claim-table-row">
      <ClaimsTableCell itemType="status">
        <ClaimStatusBadge status={status} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="type">
        <ClaimsTypeBadge claimType={claimType} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="value">
        <ClaimsValue currency={netValueCurrency} value={netValue} id={String(id)} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="date">
        <ClaimsTableSubmissionDate claim={claim} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="code">
        <Text ink>{trackingCode}</Text>
      </ClaimsTableCell>
      <ClaimsTableCell itemType="code">
        <Text ink>{recipientCountryCode?.toUpperCase()}</Text>
      </ClaimsTableCell>
      <ClaimsTableCell itemType="dor-status">
        <DorStatusBadge dorStatus={dorStatus} />
      </ClaimsTableCell>
      <ClaimsTableCell itemType="action">
        <ClaimsTableActionDropdownButton
          claim={claim}
          onTakeActionButtonClick={onTakeActionButtonClick}
          onCancelClaimButtonClick={onCancelClaimButtonClick}
          onContinueClaimSubmission={onContinueClaimSubmission}
        />
      </ClaimsTableCell>
    </tr>
  );
}

export default ClaimsTableRow;
